import React, {useState, useEffect} from 'react'
import { Image } from 'react-bootstrap'
import a5 from "../../../../assets/edgemarketing/a5.png"

import '../edgemarketing.css'


function Tabmockup() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click
    };


  return (
    <div 
    fluid 
    className='container-section' 
    style={{
     padding: 0,
      backgroundColor:"#101010",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh'
      }}>
       <Image src={a5} alt='a32' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
    </div>
    
     
    
  )
}

export default Tabmockup
